module.exports = __webpack_public_path__ + "static/media/walking-watermelon.e5ceb95d.svg";